const romeTimeFormat = new Intl.DateTimeFormat('it-IT', {
  timeZone: 'Europe/Rome',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
})

export const formatRomeTime = (isoDate: string): string => romeTimeFormat.format(new Date(isoDate))
